import { datalayer, isInitialized, event } from '@zillow/universal-analytics';
import isEmpty from 'lodash/isEmpty';
import { safeTrack } from '../../../../util/tracking';
// import { captureException } from './trackError';

import { getEnvelopeBlock, getClickstreamBlock, getSemanticBlock } from './analyticsHelpers';

export function trackNewLaneSRPEvent(eventName, eventObject, triggerSourceKey = '') {
    let newLaneEvent = null;
    if (isInitialized()) {
        datalayer
            .getAll({ screenName: 'sxp' })
            .then(data => {
                if (data && !isEmpty(data)) {
                    newLaneEvent = data;
                }
            })
            .catch(e => {
                console.error(e);
                // captureException(
                //     `trackNewLaneEvent: eventName: ${eventName} - ZUA data layer error: ${e}`,
                //     { level: 'error' }
                // );
            })
            .finally(() => {
                if (newLaneEvent) {
                    newLaneEvent = {
                        ...newLaneEvent,
                        semantic: getSemanticBlock(eventName),
                        clickstream_trigger: getClickstreamBlock(eventName, triggerSourceKey),
                        envelope: getEnvelopeBlock(eventName),
                    };
                }
                if (eventObject) {
                    safeTrack(
                        eventObject,
                        // @ts-expect-error: for some reason we add the newLaneEvent key when everything seems to indicate we shouldn't?
                        newLaneEvent ? { newLaneEvent: newLaneEvent } : null
                    );
                } else if (newLaneEvent) {
                    event(newLaneEvent);
                }
            });
    } else if (eventObject) {
        safeTrack(eventObject);
    }
}

export function trackNavAdDisplayState(e) {
    const displayState = e.isEmpty ? 'Empty' : 'Displayed';
    safeTrack({
        category: 'Nav Ad',
        action: displayState,
    });
}

export function trackDisplayAdDisplayState(e) {
    const displayState = e.isEmpty ? 'Empty' : 'Displayed';
    safeTrack({
        category: 'Display Ad',
        action: displayState,
    });
}
